import { FC } from 'react';

import { Box, BoxProps, Flex, Tooltip } from '@bonusly/design-system';

import { Bonus, BonusPrivacy } from '../../../../../types/bonus';
import { usePrivacyBadge } from '../../components/bonus/hooks/use-privacy-badge';

interface PrivacyBadgeProps extends BoxProps {
	bonus: Bonus;
}

export const PrivacyBadge: FC<PrivacyBadgeProps> = ({ bonus: { privacy }, ...rest }) => {
	const { icon, text, tooltip } = usePrivacyBadge(privacy);

	if (privacy === BonusPrivacy.Public) {
		return null;
	}

	return (
		<Tooltip label={tooltip} textAlign="center">
			<Flex alignItems="center" color="gray.600" data-testid="bonus-privacy" display="inline-flex" {...rest}>
				{icon}

				<Box as="span" ml={1} fontSize="sm" fontWeight="normal">
					{text}
				</Box>
			</Flex>
		</Tooltip>
	);
};
